// How sends, mailings and call rounds look wherever they appear on the
// campaign page: channel icons and plan state -> badge mappings. Words come
// from shared-core's direct-mail glossary maps; this file only decides how
// they look.

import { Mail, Package, Phone, Send, type LucideIcon } from "lucide-react";
import type {
  CadenceChannel,
  PlanStepState,
} from "@shared-core/data/api-types";
import {
  STEP_CHANNEL_LABELS,
  STEP_STATE_LABELS,
} from "@shared-core/domain/direct-mail-campaigns";
import { Badge } from "../../primitives/badge";

export const STEP_CHANNEL_ICONS: Record<CadenceChannel, LucideIcon> = {
  direct_mail: Package,
  email: Mail,
  call: Phone,
  enclosure: Send,
};

type BadgeVariant = "outline" | "warning" | "neutral" | "success";

const STEP_STATE_VARIANTS: Record<PlanStepState, BadgeVariant> = {
  draft: "outline",
  ready: "warning",
  posted: "neutral",
  sent: "neutral",
  open: "success",
};

export function StepStateBadge({ state }: { state: PlanStepState }) {
  return (
    <Badge variant={STEP_STATE_VARIANTS[state]}>
      {STEP_STATE_LABELS[state]}
    </Badge>
  );
}

export function ChannelIcon({
  channel,
  className = "size-4",
}: {
  channel: CadenceChannel;
  className?: string;
}) {
  const Icon = STEP_CHANNEL_ICONS[channel];
  return (
    <Icon className={className} aria-label={STEP_CHANNEL_LABELS[channel]} />
  );
}
